module.exports = __webpack_public_path__ + "static/img/header_bg1.6f2fbd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/mitu/special/head/header_bg1.png
// module id = 2hBc
// module chunks = 8